<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Preparation Tips">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e159" xmlns:saxon="http://icl.com/saxon">Preparation Tips
            </a></h1><a id="d0e159" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e159" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e159" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e159" xmlns:saxon="http://icl.com/saxon">
</a><p><a id="d0e159" xmlns:saxon="http://icl.com/saxon"></a><a id="chiff" xmlns:saxon="http://icl.com/saxon"><span class="subhead">Chiffonade</span>
        This is a term used for slicing delicate herbs or lettuces into very thin strips. It is most
        easily accomplished by stacking the leaves of whatever you’re using, such as fresh basil, in
        a manageable pile, roughly 8 leaves or so. These are then rolled, like a cigar, and chopped
        through with a sharp chef’s knife to create thin 1/8-inch-wide ribbons. This method prevents
        bruising or damaging the delicate greens. </a></p><a id="chiff" xmlns:saxon="http://icl.com/saxon">
</a><p><a id="chiff" xmlns:saxon="http://icl.com/saxon"></a><a id="croot" xmlns:saxon="http://icl.com/saxon"><span class="subhead">Celery root
          (celeriac) tips</span> Once difficult to find, celery root is a mainstay in the produce
        section of most grocery markets, particularly during cooler months. Look for its distinctive
        knobby, pocked exterior and large, bulbous shape. It’s not pretty, but it sure is delicious.
        Like rutabaga, it has a double skin: the thick outer skin, and an inner skin, usually about
        1/4 inch (6 mm) thick. To remove both, which is necessary, cut off the top of the root and
        position it bottom side down securely on your cutting surface. Using a sharp chef’s knife,
        cut down and through the skins in broad swaths, as you would remove the rind from a melon.
        Keep turning until you’re all the way through the root. Cut off any brown flecks or
        discolored areas, slice, and cook quickly. It will discolor if left exposed to oxygen more
        than a few minutes in its raw state. </a></p><a id="croot" xmlns:saxon="http://icl.com/saxon">
</a><p><a id="croot" xmlns:saxon="http://icl.com/saxon"></a><a id="avocado" xmlns:saxon="http://icl.com/saxon"><span class="subhead">Avocado Tips
        </span>There are several avocado varieties, but the smaller, thicker skinned dark-green Hass
        avocados have more concentrated texture and flavor than some of their counterparts and are
        most commonly available. All avocados are ripe when they yield slightly to pressure from
        your forefinger. They become darker green to almost black when they are very ripe, and will
        start to develop soft and discolored spots at this point. To accelerate ripening, place
        avocado in a paper bag with a ripe banana or another ripe fruit. To decelerate the ripening,
        refrigerate until ready to use. To remove the pit, once avocado is halved, tap hard with the
        cutting edge of a large knife and twist. It should pop right out. </a></p><a id="avocado" xmlns:saxon="http://icl.com/saxon">
<p><span class="subhead">How to Clean a Leek </span>Because leeks grow up from the dirt and
        their layers are so tightly bound, they tend to harbor grit and dirt in surprise places and
        need to be cleaned very carefully. There are two ways to do it. In both cases, most of the
        tough green tops are cut off and discarded or saved for making stock. For lightly soiled
        leeks, cut an X about 1 inch deep into the top of the trimmed leek and run it under water,
        loosening the petals around the X to remove any grit. Extra-dirty leeks should be cut into
        thick slices after they’re trimmed, and soaked in a bowl or sink of cold water; give good
        swish, rinse, and repeat until all of the grit is gone. </p>
</a><p><a id="avocado" xmlns:saxon="http://icl.com/saxon"></a><a id="pom" xmlns:saxon="http://icl.com/saxon"><span class="subhead">Pomegranate Power
        </span>Considered a superfood for its high nutrient content, pomegranate can be purchased in
        its whole form during the cooler months and, increasingly, already seeded or juiced. The
        seeds are called arils and they look like little rubies. Getting them out of their tightly
        knitted pockets can be a challenge, but it’s worth the effort. An easy way to get to the
        fruit is to quarter the pomegranate, revealing the four cores, then peel back the bitter
        pith pockets and release the arils. One pomegranate will yield 1 to 2 cups (175 to 350 g) of
        arils. </a></p><a id="pom" xmlns:saxon="http://icl.com/saxon">
</a><p><a id="pom" xmlns:saxon="http://icl.com/saxon"></a><a id="shrimp" xmlns:saxon="http://icl.com/saxon"><span class="subhead">An Easy way to
          Devein Shrimp </span>Use a good set of kitchen shears and cut through the exterior,
        rounded edge of the shrimp from top to just above the tail. Cut right through the shell and
        about 1/8 inch (3 mm) deep to expose the vein. Use your fingers or a paring knife to guide
        out the vein and discard. Carefully rinse the shrimp and shells. This works equally well for
        cooked and raw shrimp. </a></p><a id="shrimp" xmlns:saxon="http://icl.com/saxon">
<div class="mediaobject" title="Photo of vegetables.">
<img alt="Photo of vegetables." src="images/Outtake_8-8340-Edit-Edit-Edit-944.jpg"/>
</div>
</a></div><a id="shrimp" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?62e90988